var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 64C23.5131 64 15.3737 60.6286 9.37258 54.6274C3.37142 48.6263 -2.3609e-07 40.4869 0 32C2.36091e-07 23.5131 3.37142 15.3737 9.37258 9.37258C15.3737 3.37142 23.5131 -1.01206e-07 32 0V3.2C24.3618 3.2 17.0364 6.23428 11.6353 11.6353C6.23428 17.0364 3.2 24.3618 3.2 32C3.2 39.6382 6.23428 46.9636 11.6353 52.3647C17.0364 57.7657 24.3618 60.8 32 60.8V64Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 0C36.2023 5.01119e-08 40.3635 0.827705 44.2459 2.43586C48.1283 4.04401 51.6559 6.40111 54.6274 9.37259C57.5989 12.3441 59.956 15.8717 61.5641 19.7541C63.1723 23.6366 64 27.7977 64 32H60.8C60.8 28.2179 60.0551 24.4729 58.6077 20.9787C57.1604 17.4845 55.039 14.3097 52.3647 11.6353C49.6903 8.961 46.5155 6.83961 43.0213 5.39227C39.5271 3.94494 35.7821 3.2 32 3.2V0Z",
    fill: "#EB5C37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 32C64 39.0443 61.6756 45.8918 57.3873 51.4804C53.099 57.069 47.0865 61.0864 40.2822 62.9096L39.454 59.8187C45.5778 58.1778 50.9891 54.5621 54.8486 49.5323C58.708 44.5026 60.8 38.3399 60.8 32H64Z",
    fill: "#FAB9A4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.c86084ca5d61b01009c67f8c42aea997.svg";
export { ForwardRef as ReactComponent };